module.exports = __webpack_public_path__ + "media/site_templates/www.cheapplumber.net.au/images/our_services_3-6e9531b212edafb8f7169438290a6e69.jpg";